export default "__VITE_ASSET__BliZS2VO__"